import React, { useState } from 'react';

const Portfolio = () => {
    const [database,setDatabase] = useState([
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-1.jpg",
            pool:"App 1",
            group:"APP",
            auther:"shaon"
        },
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-2.jpg",
            pool:"WEB 3",
            group:"WEB",
            auther:"shaon"
        },
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-3.jpg",
            pool:"App 2",
            group:"APP",
            auther:"shaon"
        },
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-4.jpg",
            pool:"Card 2",
            group:"CARD",
            auther:"shaon"
        },
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-5.jpg",
            pool:"Web 2",
            group:"WEB",
            auther:"shaon"
        },
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-6.jpg",
            pool:"App 3",
            group:"APP",
            auther:"shaon"
        },
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-7.jpg",
            pool:"Card 1",
            group:"CARD",
            auther:"shaon"
        },
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-8.jpg",
            pool:"Card 3",
            group:"CARD",
            auther:"shaon"
        },
        {
            image:"https://bootstrapmade.com/demo/templates/Ninestars/assets/img/portfolio/portfolio-9.jpg",
            pool:"Web 3",
            group:"WEB",
            auther:"shaon"
        },
    ]);

    const [database2,setDatabas2]= useState([...database]);

    const filterData= (fill)=>{
        if(fill==="auther"){
            setDatabas2([...database])
        }else{
            setDatabas2(database.filter((ss)=>{
            
                return ss.group===fill;
               
            }));
        }
        
    }
  return (
    <>
      <div className='MainPortfolio'>
      <div className='serviceText'>
            <h4>Portfolio</h4>
            <h2>Check out our beautifull portfolio</h2>
            <div></div>
        </div>

        <div className='portfolioCard'>
            <div className='portfolioTitle'>
                <button onClick={()=>filterData("auther")}>All</button>
                <button onClick={()=>filterData("APP")}>App</button>
                <button onClick={()=>filterData("CARD")}>Card</button>
                <button onClick={()=>filterData("WEB")}>Web</button>
            </div>

            <div className='portfolioCardSec'>
                
                {
                    database2.map(({image,pool,group},index)=>{
                        return (
                            <div className='Cards' key={index}>
                    <img src={image} className='image-fluid' alt={index} />
                    <div className='hiddenPortCard'>
                        <div className='hiddenIcon'>
                        <i className="fa fa-chain"></i>
                        <i className="fa fa-arrows"></i>
                        </div>
                        <h4>{pool}</h4>
                        <h5>{group}</h5>
                    </div>
                </div>
                        )
                    })
                }
                
            </div>
        </div>
      </div>
    </>
  )
}

export default Portfolio
